import React from "react";
import { 
  Container, 
  Grid, 
  Paper, 
  Typography, 
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link
} from "@mui/material";
import { 
  Security, 
  Cookie, 
  Shield, 
  Policy, 
  ContactMail,
  FiberManualRecord
} from "@mui/icons-material";
import Color from "../../theme/color";
import DashBoardTopTabBar from "../../components/dashborad-app-bar";
import ContactUsTopTabBar from "../../components/contactUs-app-bar";
export const ContactUsMenu = ["Home", "Events", "About Us"];
const PrivacyAndPolicy: React.FC = () => {
  


  return (
    // <Box sx={{ py: 4, backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      < >
        {/* Hero Banner */}
          
        {/* <Grid container spacing={3}> */}
          <Grid item xs={12}>
            <ContactUsTopTabBar
                   backgroundColors={"transparent"}
                   textColor={"#fff"}
                   boxShadow={"none"}
                   iconColor={"#fff"}
                   pages={ContactUsMenu}
                   event={"events"}
                 />
            <Paper 
              elevation={2} 
              sx={{ 
                borderRadius: 2,
                overflow: "hidden",
                marginBottom: 4 
              }}
            >
              <Box
                sx={{
                  backgroundImage: 'url("https://eventprix.com/wp-content/uploads/2023/04/Contact-Us-Banner.jpg")',
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: { xs: "200px", md: "300px" },
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                  }}
                />
                <Typography 
                  variant="h2" 
                  sx={{ 
                    zIndex: 1, 
                    color: "white",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "2rem", md: "3rem" }
                  }}
                >
                  Privacy Policy
                </Typography>
              </Box>
            </Paper>
          </Grid>
        {/* </Grid> */}

        {/* Policy Content */}
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper 
              elevation={1} 
              sx={{ 
                p: { xs: 3, md: 6 },
                borderRadius: 2,
                backgroundColor: "white"
              }}
            >
              {/* Introduction */}
              <Box sx={{ mb: 4 }}>
                <Typography 
                  variant="h4" 
                  gutterBottom 
                  sx={{ 
                    color: Color.color13,
                    fontWeight: "bold",
                    mb: 3
                  }}
                >
                  Our Commitment to Your Privacy
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, fontSize: "1.1rem" }}>
                  At EventPrix, we are deeply committed to protecting your privacy and ensuring 
                  the security of your personal information. This Privacy Policy explains how we 
                  collect, use, disclose, and safeguard your information when you use our event 
                  ticketing platform.
                </Typography>
              </Box>

              {/* Information Collection */}
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Policy sx={{ color: Color.color13, mr: 2, fontSize: "2rem" }} />
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: Color.color13,
                      fontWeight: "bold"
                    }}
                  >
                    Information We Collect
                  </Typography>
                </Box>
                
                <Typography variant="h6" sx={{ mb: 2, color: "#555" }}>
                  Personal Information
                </Typography>
                <List dense>
                  {[
                    "Name, email address, and phone number for account registration",
                    "Billing and payment information for ticket purchases",
                    "Event preferences and booking history",
                    "Communication preferences and marketing consent"
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <FiberManualRecord sx={{ fontSize: "0.5rem", color: Color.color13 }} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>

                <Typography variant="h6" sx={{ mb: 2, mt: 3, color: "#555" }}>
                  Technical Information
                </Typography>
                <List dense>
                  {[
                    "IP address, browser type, and operating system",
                    "Device information and unique identifiers",
                    "Website usage data and analytics",
                    "Cookies and tracking technologies data"
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <FiberManualRecord sx={{ fontSize: "0.5rem", color: Color.color13 }} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* How We Use Information */}
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Shield sx={{ color: Color.color13, mr: 2, fontSize: "2rem" }} />
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: Color.color13,
                      fontWeight: "bold"
                    }}
                  >
                    How We Use Your Information
                  </Typography>
                </Box>
                
                <List dense>
                  {[
                    "Process ticket purchases and event registrations",
                    "Provide customer support and communicate about your bookings",
                    "Send important updates about events you've registered for",
                    "Improve our services and personalize your experience",
                    "Send marketing communications (with your consent)",
                    "Prevent fraud and ensure platform security",
                    "Comply with legal obligations"
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <FiberManualRecord sx={{ fontSize: "0.5rem", color: Color.color13 }} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* Data Sharing */}
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Security sx={{ color: Color.color13, mr: 2, fontSize: "2rem" }} />
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: Color.color13,
                      fontWeight: "bold"
                    }}
                  >
                    Data Sharing and Disclosure
                  </Typography>
                </Box>
                
                <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
                  We may share your information with:
                </Typography>
                
                <List dense>
                  {[
                    "Event organizers for events you register for",
                    "Payment processors to complete transactions",
                    "Service providers who help us operate our platform",
                    "Legal authorities when required by law",
                    "Third parties in case of business transfers or mergers"
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <FiberManualRecord sx={{ fontSize: "0.5rem", color: Color.color13 }} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* Cookies */}
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Cookie sx={{ color: Color.color13, mr: 2, fontSize: "2rem" }} />
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: Color.color13,
                      fontWeight: "bold"
                    }}
                  >
                    Cookies and Tracking Technologies
                  </Typography>
                </Box>
                
                <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
                  We use cookies and similar technologies to:
                </Typography>
                
                <List dense>
                  {[
                    "Remember your preferences and settings",
                    "Provide personalized content and recommendations",
                    "Analyze website traffic and user behavior",
                    "Enable social media features",
                    "Improve our marketing efforts"
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <FiberManualRecord sx={{ fontSize: "0.5rem", color: Color.color13 }} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
                
                <Typography variant="body1" sx={{ mt: 2, lineHeight: 1.8 }}>
                  You can control cookie preferences through your browser settings. 
                  However, disabling cookies may affect some website functionality.
                </Typography>
              </Box>

              {/* Data Security */}
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Security sx={{ color: Color.color13, mr: 2, fontSize: "2rem" }} />
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: Color.color13,
                      fontWeight: "bold"
                    }}
                  >
                    Data Security
                  </Typography>
                </Box>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  We implement comprehensive security measures including encryption, 
                  secure servers, and regular security assessments to protect your 
                  personal information. While we take reasonable precautions, no 
                  electronic transmission or storage is 100% secure. We encourage 
                  you to use strong passwords and keep your login credentials confidential.
                </Typography>
              </Box>

              {/* Your Rights */}
              <Box sx={{ mb: 4 }}>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    color: Color.color13,
                    fontWeight: "bold",
                    mb: 2
                  }}
                >
                  Your Rights and Choices
                </Typography>
                
                <List dense>
                  {[
                    "Access and review your personal information",
                    "Update or correct inaccurate data",
                    "Request deletion of your personal data",
                    "Opt-out of marketing communications",
                    "Export your data in a portable format",
                    "Withdraw consent where applicable"
                  ].map((item, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <FiberManualRecord sx={{ fontSize: "0.5rem", color: Color.color13 }} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* Policy Updates */}
              <Box sx={{ mb: 4 }}>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    color: Color.color13,
                    fontWeight: "bold",
                    mb: 2
                  }}
                >
                  Policy Updates
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  We may update this Privacy Policy periodically to reflect changes 
                  in our practices or legal requirements. We will notify you of 
                  significant changes by email or through prominent notices on our 
                  website. The "Last Updated" date at the bottom of this policy 
                  indicates when it was last revised.
                </Typography>
              </Box>

              {/* Contact Information */}
              <Box sx={{ 
                backgroundColor: "#f8f9fa", 
                p: 3, 
                borderRadius: 2,
                borderLeft: `4px solid ${Color.color13}`
              }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <ContactMail sx={{ color: Color.color13, mr: 2, fontSize: "2rem" }} />
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: Color.color13,
                      fontWeight: "bold"
                    }}
                  >
                    Contact Us
                  </Typography>
                </Box>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  If you have any questions, concerns, or requests regarding this 
                  Privacy Policy or our data practices, please contact us:
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  Email:{" "}
                  <Link 
                    href="mailto:contact@eventprix.com" 
                    sx={{ color: Color.color13, fontWeight: "bold" }}
                  >
                    contact@eventprix.com
                  </Link>
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mt: 1 }}>
                  We typically respond to all inquiries within 2 business days.
                </Typography>
              </Box>

              {/* Last Updated */}
              <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid #e0e0e0" }}>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: "#666",
                    fontStyle: "italic"
                  }}
                >
                  Last Updated: {new Date().toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </>
    // </Box>
  );
};

export default PrivacyAndPolicy;